import { Navigate, useParams } from 'react-router-dom';

export const RedirectLegacyMessengerLink = () => {
  const { senderId } = useParams();
  return <Navigate to={`/messenger/user/${senderId}`} replace />;
};
